<template>
	<div class="menu-item">
		<template v-if="menu?.moduleVOS?.length">
			<div
				v-for="module in menu.moduleVOS"
				:key="module.moduleId"
				class="module-block"
				:class="{
					'module-block--w100': module.column === 100,
					'module-block--padding': !!getModuleBgMap[module.moduleId],
					'module-block--margin': !getModuleBgMap[module.moduleId]
				}"
			>
				<div v-if="getModuleBgMap[module.moduleId]" class="module-block__bg ex2rem-min-w1200-layout-next">
					<el-image
						style="width: 100%; height: 100%"
						:src="getModuleBgMap[module.moduleId].getCover()"
						fit="cover"
					></el-image>
				</div>
				<div class="module-header mb-32">
					<div class="header-label">{{ module.name }}</div>
					<div v-if="module.type !== 2" class="header-to" @click="viewModuleMore(menu, module)">
						<span>{{ $t('enterprise.see-more') }}</span>
						<i class="iconfont icon-flip-right"></i>
					</div>
				</div>

				<slot name="module" :menu="menu" :module="module" />
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'MenuBlock'
};
</script>

<script setup>
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { computed } from 'vue';
import { useCurrentContext } from './context';

defineProps({
	menu: {
		type: Object,
		required: true
	}
});

const context = useCurrentContext();
const getModuleBgMap = computed(() => context.getModuleBgMap);

const { viewModuleMoreInFlow } = useNavigation();

const viewModuleMore = (menu, module) => {
	viewModuleMoreInFlow(menu, module);
};
</script>

<style lang="less" scoped>
.menu-item {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	&:not(:first-child) {
		.module-block {
			margin-top: 64px;
		}
	}
	&:last-child {
		padding-bottom: 64px;
	}
}

.module-block {
	width: calc(50% - 48px);
	display: flex;
	flex-direction: column;
	position: relative;
	z-index: 1;

	&.module-block--w100 {
		width: 100%;
	}
	&.module-block--padding {
		padding: 64px 0;
	}
	&.module-block--margin {
		margin-top: 64px;
	}
	.module-block__bg {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 100vw;
		z-index: -1;
		pointer-events: none;
	}
}

.module-header {
	height: 42px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.header-label {
		color: #1d2129;
		font-size: 24px;
		font-weight: 600;
		line-height: 140%; /* 42px */
	}
	.header-to {
		display: flex;
		align-items: center;
		cursor: pointer;

		span {
			color: #4e5969;
			text-align: right;
			font-size: 14px;
			font-weight: 400;
			line-height: 16px; /* 114.286% */
		}
		.iconfont {
			font-size: 16px;
			color: #4e5969;
		}
	}
}
</style>
